import { Tag } from "antd";
import { EListingStatus } from "../types/listing.type";

const RenderListingStatus = ({ status }: { status: EListingStatus }) => {
	if (!status) return <></>;
	let color = "";
	switch (status) {
		case EListingStatus.PUBLISH:
			color = "blue";
			break;

		case EListingStatus.OPEN:
			color = "warning";
			break;

		case EListingStatus.EXPIRED:
			color = "red";
			break;

		case EListingStatus.CLOSED:
			color = "green";
			break;

		case EListingStatus.UNPUBLISH:
			color = "volcano";
			break;

		default:
			color = "-";
			break;
	}

	return <Tag color={color}>{EListingStatus[status].toUpperCase()}</Tag>;
};

export default RenderListingStatus;
